module.exports = __webpack_public_path__ + "img/kong2.aa9f4251.png";